import { useSyncExternalStore } from 'react'
import { ulid } from 'ulid'

export const CANVAS_ID = 'canvas' // the one canvas every person sees (G4, 2026-10-18)
const listeners = new Set()

function emit() {
  for (const cb of listeners) cb()
}

window.addEventListener('popstate', emit)

export function navigate(path, { replace = false } = {}) {
  if (replace) history.replaceState(null, '', path)
  else history.pushState(null, '', path)
  emit()
}

export function usePath() {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb)
      return () => listeners.delete(cb)
    },
    () => location.pathname
  )
}

// Routes:
//   /plugins      the plugin manager
//   /settings     the settings page (AI providers, etc.)
//   /v/<viewId>   one view (a board); NEVER auto-created
//   /             the one canvas: goes to /v/canvas
export function parseRoute(path) {
  if (path === '/plugins') return { page: 'plugins' }
  if (path === '/settings') return { page: 'settings' }
  const view = path.match(/^\/v\/([A-Za-z0-9_-]+)$/)
  if (view) return { page: 'view', viewId: view[1] }
  return { page: 'home' }
}

export function newViewId() {
  return ulid().toLowerCase()
}
